import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/orden_trabajo/getOrdenesTrabajoByUsuario.php';

export default function getOrdenesTrabajoByUsuario({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}